export default __webpack_public_path__ + "static/media/All_American.63fdd0c0.jpeg";